export const visibleLengthFilter = (component, selectedComponent) => {
  return component
    ? selectedComponent?.filter((element) => element.visible).length
    : null
}
